import "./AccessRoleAddComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import commonService from "../../../shared/services/common.service";
import {setCurrentNavParams, setSideMenuView} from "../../../store/actions/header.action";
import {CommonService} from "../../../shared/services";
import {useDispatch} from "react-redux";
import LottieFileGenarationComponent
    from "../../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";
import {ImageConfig} from "../../../constants";
import StatusCardComponent from "../../../shared/components/status-card/statusCardComponent";
import SwitchComponent from "../../../shared/components/core/switch/switchComponent";
import ButtonComponent from "../../../shared/components/core/button/ButtonComponent";
import _ from "lodash";
import InputComponent from "../../../shared/components/core/input/InputComponent";
import {Grid} from "@material-ui/core";
import {useNavigate} from "react-router-dom";

interface AccessRoleAddComponentProps {

}

const AccessRoleAddComponent = (props: AccessRoleAddComponentProps) => {
    const dispatch = useDispatch();
    const [saveDisable, setSaveDisable] = useState<boolean>(true);
    const [accessLevelDetails, setAccessLevelDetails] = useState<any>([]);
    const [accessLevelDetailsLoading, setAccessLevelDetailsLoading] = useState<boolean>();
    const [accessLevelDetailsLoadingFailed, setAccessLevelDetailsLoadingFailed] = useState<boolean>();
    const [accessLevelDetailsLoaded, setAccessLevelDetailsLoaded] = useState<boolean>();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [roleName, setRoleName] = useState<string>('');
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(setCurrentNavParams("Back", "Access Level", CommonService._routeConfig.AccessLevelListRoute()));
        dispatch(setSideMenuView('compact'));
    }, [dispatch]);

    const getStaticAccessLevelDetails = useCallback(() => {
        const payload = {};
        setAccessLevelDetailsLoaded(false);
        setAccessLevelDetailsLoading(true);
        setAccessLevelDetailsLoadingFailed(false);
        commonService._accessLevel.getStaticAccessLevelData(payload)
            .then((response: any) => {
                setAccessLevelDetails(response.data);
                setAccessLevelDetailsLoaded(true);
                setAccessLevelDetailsLoading(false);
                setAccessLevelDetailsLoadingFailed(false);
            })
            .catch((error: any) => {
                setAccessLevelDetailsLoaded(false);
                setAccessLevelDetailsLoading(false);
                setAccessLevelDetailsLoadingFailed(true);
            })
    }, []);

    const handleFeatureAccessChange = useCallback((accessLevelDetails: any, module: string, feature: string) => {
        const data = _.cloneDeep(accessLevelDetails);
        const updatedData = data.map((prevState: any) => {
            if (prevState.module === module) {
                const featureData = prevState.features.map((featureItem: any) => {
                    if (featureItem.feature === feature) {
                        return {...featureItem, isAccessible: !featureItem.isAccessible}
                    }
                    return featureItem;
                })
                return {...prevState, features: featureData}
            }
            return prevState;
        })
        setAccessLevelDetails(updatedData);
    }, [])

    const handleModuleAccessChange = useCallback((module: string, isAccessible: boolean) => {
        setAccessLevelDetails((prevState: any) => {
            const updatedData = prevState.map((item: any) => {
                if (item.module === module) {
                    if (isAccessible) {
                        const featuseDeselected = item.features.map((featureItem: any) => {
                            return {...featureItem, isAccessible: false}
                        })
                        return {...item, features: featuseDeselected, isAccessible: !item.isAccessible}
                    }
                    return {...item, isAccessible: !item.isAccessible}
                }
                return item;
            })
            return updatedData;
        })
    }, [])

    useEffect(() => {
        getStaticAccessLevelDetails();
    }, [getStaticAccessLevelDetails])

    useEffect(() => {
        const count = accessLevelDetails?.filter((item: any) => {
            return item.isAccessible && item.features.filter((featureItem: any) => {
                return featureItem.isAccessible;
            }).length > 0;
        }).length;
        count > 0 ? setSaveDisable(false):setSaveDisable(true);
    }, [accessLevelDetails])

    const handleSaveAccessLevelDetails = useCallback((accessLevelDetails: any) => {
        const payload = {
            'role': roleName,
            'code':roleName,
            'aclRules': accessLevelDetails
        };
        setIsLoading(true);
        commonService._accessLevel.addNewAclRole(payload)
            .then((response: any) => {
                setIsLoading(false);
                navigate(CommonService._routeConfig.AccessLevelListRoute());
            }).catch((error: any) => {
            setIsLoading(false);
        })
    }, [roleName,navigate])

    return (
        <div className={'access-role-add-component access-level-details-component details-screen screen'}>
            {
                accessLevelDetailsLoading && <div className="h-v-center">
                    <LottieFileGenarationComponent
                        loop={true}
                        autoplay={true}
                        animationData={ImageConfig.LoadingLottieFile}/>
                </div>
            }
            {
                accessLevelDetailsLoadingFailed && <>
                    <StatusCardComponent title={"TestOrder details failed to load"}/>
                </>
            }
            {
                accessLevelDetailsLoaded && <>
                    <div className={'access-level-details-body-wrapper'}>
                        <div className={'access-role-add-body-title'}>
                            Add Access Role
                        </div>
                        <div className={'access-role-add-sub-title'}>
                            Role Name
                        </div>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <InputComponent
                                    name={"roleName"}
                                    label={"Enter Role Name*"}
                                    placeholder={"Enter Role Name"}
                                    type={"text"}
                                    value={''}
                                    onChange={(name:string) => {
                                        setRoleName(name)
                                    }}
                                />
                            </Grid>
                        </Grid>
                        <div className={"access-role-add-sub-title"}>Permissions</div>
                        <div className={'horizontal-line'}></div>
                        {
                            accessLevelDetails?.map((item: any, index: number) => {
                                return (
                                    <>
                                        <div className={'access-level-details-body-module-and-feature-wrapper'} key={index}>
                                            <div className={'access-level-details-body-module-wrapper'}>
                                                <div
                                                    className={'access-level-details-body-module-title-description-wrapper'}>
                                                    <div className={'access-level-details-body-module-title'}>
                                                        {item.module}
                                                    </div>
                                                    <div className={'access-level-details-body-module-description'}>
                                                        {`Access to edit the features of ${item.module}
                                                module.`}
                                                    </div>
                                                </div>
                                                <div className={'access-level-details-body-module-switch-wrapper'}>
                                                    <SwitchComponent
                                                        size={"small"}
                                                        checked={item.isAccessible}
                                                        onUpdate={() => handleModuleAccessChange(item.module, item?.isAccessible)}/>
                                                </div>
                                            </div>
                                            <div className={'access-level-details-body-feature-wrapper'}>
                                                {
                                                    item.isAccessible && item.features.map((feature: any, index: number) => {
                                                        return (
                                                            <div className={'access-level-details-feature-wrapper'}>
                                                                <div
                                                                    className={'access-level-details-body-feature-title-description-wrapper'}
                                                                    key={index}>
                                                                    <div className={'access-level-details-body-feature-title'}>
                                                                        {feature.feature}
                                                                    </div>
                                                                    <div
                                                                        className={'access-level-details-body-feature-description'}>
                                                                        {feature.description}
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    className={'access-level-details-body-feature-switch-wrapper'}>
                                                                    <SwitchComponent
                                                                        size={"small"}
                                                                        checked={feature.isAccessible}
                                                                        onUpdate={() => handleFeatureAccessChange(accessLevelDetails, item.module, feature?.feature)}/>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                        <div className={'horizontal-line'}></div>
                                    </>
                                )
                            })
                        }
                        <div className={'access-level-details-actions-wrapper'}>
                            <ButtonComponent
                                className={"width-25 mrg-right-10"}
                                color={"secondary"}
                                type={"button"}
                                variant={"outlined"}
                                disabled={isLoading}
                                fullWidth={false}
                                handleClick={() => {
                                    navigate(commonService._routeConfig.AccessLevelListRoute())
                                }}
                            >
                                Cancel
                            </ButtonComponent>
                            <ButtonComponent
                                className="width-25"
                                type="button"
                                color={"primary"}
                                variant={"contained"}
                                isLoading={isLoading}
                                disabled={isLoading || !roleName || saveDisable}
                                fullWidth={false}
                                handleClick={() => handleSaveAccessLevelDetails(accessLevelDetails)}
                            >
                                Submit
                            </ButtonComponent>
                        </div>
                    </div>

                </>
            }
        </div>
    );

};

export default AccessRoleAddComponent;
